export default __webpack_public_path__ + "static/media/purpleKustomize.c1f75272.svg";